import { render } from "./FormTextarea.vue?vue&type=template&id=0d77b5f7"
import script from "./FormTextarea.vue?vue&type=script&lang=js"
export * from "./FormTextarea.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui-components/FormTextarea.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0d77b5f7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0d77b5f7', __exports__)) {
    api.reload('0d77b5f7', __exports__)
  }
  
  module.hot.accept("./FormTextarea.vue?vue&type=template&id=0d77b5f7", () => {
    api.rerender('0d77b5f7', render)
  })

}


export default __exports__